import {Cell, Pie, PieChart, ResponsiveContainer} from 'recharts'
import React from 'react'
import ChartLegend from './ChartLegend'

const SLICE_COLORS = {
  repayment: '#10C98F',
  expenses: '#1E2739',
  tax: '#D85846',
  remaining: '#376F66',
}

const LABEL_COLORS = {
  repayment: '#076447',
  expenses: '#1E2739',
  tax: '#A14134',
  remaining: '#376F66',
}

const styles = {
  chartContainer: {
    width: '100%',
    minHeight: '200px'
  },
}

function Chart(props) {
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const RADIAN = Math.PI / 180
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5 + 30
    const x  = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy  + radius * Math.sin(-midAngle * RADIAN)

    return (
      <text className={`pie-chart-label-${index}`} x={x} y={y} fill={ LABEL_COLORS[graphData(props)[index].color]} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }

  function graphData(props) {
    const {
      financialGraph
    } = props

    const {
      repayment,
      expenses,
      remaining,
      tax,
      repaymentLabel,
      expensesLabel,
      remainingLabel,
      taxLabel,
    } = financialGraph

    return(
      [
        { name: 'Tax',        value: tax,       color: 'tax',       label: taxLabel       },
        { name: 'Expenses',   value: expenses,  color: 'expenses',  label: expensesLabel  },
        { name: 'Repayments', value: repayment, color: 'repayment', label: repaymentLabel },
        { name: 'Remaining',  value: remaining, color: 'remaining', label: remainingLabel },
      ]
    )
  }

  const data = graphData(props)

  return (
    <div>
      <div className="row">
        <div className="col-sm-7"
             style={styles.chartContainer}>
          <ResponsiveContainer>
            <PieChart
              width={320}
              height={260}>
              <Pie
                data={ data }
                innerRadius={60}
                outerRadius={80}
                paddingAngle={10}
                legendType='circle'
                label={ renderCustomizedLabel }
                labelLine={false}
                dataKey="value"
              >
                {
                  data.map((entry, index) =>
                    <Cell key={`cell-${index}`} fill={SLICE_COLORS[entry.color]}/>
                  )
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="col-sm-5 align-self-center">
          <div className="recharts-legend-wrapper">
            <ChartLegend graphData={ data } />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Chart
